import { useQuery } from "@tanstack/react-query";
import api from "../lib/apiClient";

export const useStarPerformers = () => {
	return useQuery({
		queryKey: ["star-performers"],
		queryFn: async () => {
			const { data } = await api.get("/star-performers");
			return data;
		},
	});
};